import { render, staticRenderFns } from "./ncbsegregationcheck.vue?vue&type=template&id=2407799a"
import script from "./ncbsegregationcheck.vue?vue&type=script&lang=js"
export * from "./ncbsegregationcheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports